export enum LocationNoteStatus {
  Open = 0,
  Resolved = 1,
}

export class LocationNoteViewModel {
  id?: string;
  locationId: string = "";
  note: string = "";
  status: LocationNoteStatus = LocationNoteStatus.Open;
  createdByUserName?: string;
  dateCreatedUtc?: Date;
  dateDeletedUtc?: Date;
  attachedImages?: any[];
}

